import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useGetCouriers = (queryParams, shouldFetch = true) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const res = await instance.get("users/couriers", { params });
		return res.data;
	};

	return useQuery(["users", "couriers", queryParams], () => fetch(), {
		...fetchConfig,
		enabled: shouldFetch,
	});
};

export default useGetCouriers;
